export default __webpack_public_path__ + "static/media/success_pw.b65e9e50.svg";